import React from 'react';
import PropTypes from 'prop-types';

const handleTruncatedHover = (e, value) => {
  if (e.target.offsetWidth < e.target.scrollWidth) {
    e.target.setAttribute('title', String(value ?? ''));
  } else {
    e.target.removeAttribute('title');
  }
};

const VisitCard = ({ visit }) => {
  const fields = [
    { label: 'Purpose', value: visit.purpose },
    { label: 'Leader', value: visit.leader },
    { label: 'Workers reached', value: visit.workers_interacted },
    { label: 'Total workers', value: visit.total_workers },
  ];

  return (
    <a className="max-w-74 bg-vamos-white shadow-vamos-shadow rounded-10px p-4 text-vamos-gray border-2 border-vamos-white hover:no-underline hover:border-vamos-black" href={`/sites/${visit.site_id}/visits/${visit.id}`}>
      <p className={`${visit.completed ? 'text-vamos-green1' : 'text-vamos-orange'} text-sm font-bold pt-4 pb-6`}>{visit.completed ? 'COMPLETED' : 'ATTEMPTED'}</p>
      <p className="text-lg font-bold text-vamos-black">{visit.site_name}</p>
      <p className="pb-6">{visit.date}</p>
      <div className="flex flex-col gap-1 pb-8">
        {fields.map(({ label, value }) => (
          <div key={label} className="flex items-center gap-4">
            <p className="font-bold whitespace-nowrap shrink-0">{label}</p>
            <p
              className="text-vamos-black overflow-hidden truncate min-w-0 flex-1"
              onMouseEnter={(e) => handleTruncatedHover(e, value)}
            >
              {value}
            </p>
          </div>
        ))}
      </div>
    </a>
  );
};

VisitCard.propTypes = {
  visit: PropTypes.object.isRequired,
};

export default VisitCard;
